"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var Highlight = function Highlight(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    d: "M2 20L8 12L2 4H15C15.3167 4 15.6167 4.07083 15.9 4.2125C16.1833 4.35417 16.4167 4.55 16.6 4.8L22 12L16.6 19.2C16.4167 19.45 16.1833 19.6458 15.9 19.7875C15.6167 19.9292 15.3167 20 15 20H2ZM6 18H15L19.5 12L15 6H6L10.5 12L6 18Z",
    fill: "currentColor"
  }));
};

var _default = Highlight;
exports.default = _default;